import { render, staticRenderFns } from "./ProgrammePage.vue?vue&type=template&id=78bbc4ea&scoped=true"
import script from "./ProgrammePage.vue?vue&type=script&lang=js"
export * from "./ProgrammePage.vue?vue&type=script&lang=js"
import style0 from "./ProgrammePage.vue?vue&type=style&index=0&id=78bbc4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bbc4ea",
  null
  
)

export default component.exports